// 此文件由脚本自动生成，请勿直接修改。
// This file was generated automatically by a script. Please do not modify it directly.

import { RadioTokens } from './type';

const radioTokens: RadioTokens = {
  radioGap: 'Margin-24',
  radioBlockGap: 'Margin-12',
  radioIconWidth: 'Size-7',
  radioIconGap: 'Margin-8',
  radioIconBorderWidth: 'Border-2',
  radioIconInnerSize: 'Size-3',
  radioIconBackgroundColor: 'Neutral-fill-1',
  radioIconColor: 'Neutral-border-2',
  radioIconDisabledBackgroundColor: 'Neutral-fill-2',
  radioIconDisabledColor: 'Neutral-border-1',
  radioIconHoverBackgroundColor: 'Neutral-fill-1',
  radioIconHoverColor: 'Neutral-text-3',
  radioIconCheckedBackgroundColor: 'Neutral-fill-1',
  radioIconCheckedColor: 'Brand-6',
  radioIconCheckedDisabledBackgroundColor: 'Neutral-fill-1',
  radioIconCheckedDisabledColor: 'Brand-3',
  radioIconWrapperFill: 'Neutral-fill-2',
  radioIconWrapperDark: 'Neutral-fill-3',
  radioPaddingY: 'Padding-4',
  radioSmallIconWidth: 'Size-6',
  radioSmallIconBorderWidth: 'Border-1',
  radioSmallIconInnerSize: 'Size-3',
  radioSmallLabelFontSize: '12/regular',
  radioSmallPaddingY: 'Padding-1',
  radioLargeIconWidth: 'Size-8',
  radioLargeIconBorderWidth: 'Border-2',
  radioLargeIconInnerSize: 'Size-3.5',
  radioLargeLabelFontSize: '16/regular',
  radioLargePaddingY: 'Padding-7',
  radioLabelFontColor: 'Neutral-text-5',
  radioLabelFontSize: '14/regular',
  radioLabelDisabledFontColor: 'Neutral-text-2',
};

export default radioTokens;
